const { useState, useEffect, useRef } = wp.element;
const { InspectorControls, InnerBlocks, MediaPlaceholder, TextAlignmentControl, MediaUpload, MediaUploadCheck } = wp.blockEditor;
import { TabPanel, PanelBody, Button, Card, CardFooter, CardMedia, Flex, __experimentalInputControl, __experimentalInputControlSuffixWrapper, Icon, FlexBlock, SelectControl, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl, FlexItem } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { cancelCircleFilled, closeSmall } from '@wordpress/icons';
import ColorSelector from '../color-select/color-select.js';
import { setAttributesResponsive } from '../../block/functions.js';
import DynamicDropdown from '../dynamic/dropdown/dropdown.js';
import './background.css';

const BacgroundControl = ({ attributes, setAttributes}) => {
    const [bgUrl, setBgUrl] = useState(attributes?.['background-image']?.url ? attributes?.['background-image']?.url : '');
    const [bgPosition, setBgPosition] = useState(attributes?.['background-image']?.position ? attributes?.['background-image']?.position : '');
    const [bgExternalUrl, setBgExternalUrl] = useState(attributes?.['background-image']?.['external_url'] ? attributes?.['background-image']?.['external_url'] : '');
    const [bgSize, setBgSize] = useState(attributes?.['background-image']?.size ? attributes?.['background-image']?.size : '');
    const [getDynamicImage, setGetDynamicImage] = useState(true);
    const [isShortcodeURL, setIsShortcodeURL] = useState(false);
    const backgroundTab = attributes?.state?.openBackgroundTab ?? 'classic';

    const currentDevice = useSelect((select) => {
        let resize = select('core/edit-post').__experimentalGetPreviewDeviceType().toLowerCase();
        let resizeResponsive = resize === 'desktop' ? '' : `:${resize}`;
        setBgUrl(attributes?.['background-image' + resizeResponsive]?.url ? attributes?.['background-image' + resizeResponsive]?.url : '');
        setBgExternalUrl(attributes?.['background-image' + resizeResponsive]?.external_url ? attributes?.['background-image' + resizeResponsive]?.external_url : '');
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    useEffect(() => {
        if (isShortcodeURL) {
            handleGetImageShortcode();
            setIsShortcodeURL(false);
        }
    }, [getDynamicImage]);

    const handleGetImageShortcode = () => {
        if (typeof(attributes?.['background-image']?.external_url) !== 'undefined') {
            fetch(softliteData.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'softlite_dynamic_image',
                    shortcode: attributes?.['background-image']?.external_url,
                    post_id: softliteData.postID,
                    post_type: softliteData.post_type
                })
            })
                .then(response => response.text())
                .then(src => {
                    let external_url = attributes?.['background-image']?.external_url;
                    setAttributes({ ...attributes?.['background-image'], 'background-image': { url: src, external_url: external_url } });
                    setBgExternalUrl(src);
                    setBgUrl('');
                })
                .catch(error => {
                    console.error('Error fetching shortcode data:', error);
                });
        }

    }

    const handleSelectImage = (image) => {
        setBgUrl(image.url);
        setBgExternalUrl('');
        setAttributes({...attributes?.['background-image'], 'background-image': {url: image.url, external_url: ''}});
    }

    const handleChangeBackgroundPosition = (newPosition) => {
        setBgPosition(newPosition);
        setAttributesResponsive('background-image.position', newPosition, device, setAttributes, attributes);
    }

    function debounce(func, delay) {
        let debounceTimer;
        return function (...args) {
            const context = this;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    }

    const handleChangeImageBackground = debounce((url, dynamic) => {
        const shortcodePattern = /\{.*?\}/;
        const isShortcode = shortcodePattern.test(url);
        if (isShortcode) {
            setAttributes({ ...attributes?.['background-image'], 'background-image': { external_url: url } });
            setGetDynamicImage(!getDynamicImage);
            setIsShortcodeURL(true);
        } else {
            setBgExternalUrl(url);
            setAttributes({ ...attributes?.['background-image'], 'background-image': { external_url: url } });
            setBgUrl('')
        }
    }, 300)

    const handleChangeBackgroundSize = (newSize) => {
        setAttributesResponsive('background-image.size', newSize, device, setAttributes, attributes);
        setAttributesResponsive('background-image.external_url', '', device, setAttributes, attributes);
        setBgSize(newSize);
    }

    const handleRemoveImage = () => {
        setAttributesResponsive('background-image.url', '', device, setAttributes, attributes);
        setBgUrl('');
        setBgExternalUrl('')
    }
    return (
        <>
            <TabPanel
                className="softlite-background-tab-panel"
                activeClass="active-tab"
                onSelect={(newTab) => setAttributes({state: {...attributes?.state, openBackgroundTab: newTab}})}
                initialTabName={backgroundTab}
                tabs={[
                    {
                        name: 'classic',
                        title: 'Classic',
                        className: `softlite-background-tab-setting`,
                    },
                    {
                        name: 'image',
                        title: 'Image',
                        className: `softlite-background-tab-setting`,
                    },
                ]}
            >
                {(tab) => <div>
                    {tab.name === 'classic' && (
                        <>
                            <PanelBody>
                                <ColorSelector
                                    attributes={attributes}
                                    setAttributes={setAttributes}
                                    attributeName={`background-color`}
                                />  
                            </PanelBody>
                        </>
                    )}
                    {tab.name === 'image' && (
                        <>
                            <PanelBody>
                                <Card style={{ marginBottom: '25px' }}>
                                {(attributes?.['background-image']?.url || attributes?.['background-image']?.['external_url']) && (
                                        <Button className="softlite-button-remove-image" icon={<Icon icon={closeSmall} size={14} />} onClick={() => { handleRemoveImage() }}></Button>
                                    )}
                                    <CardMedia
                                        style={{ height: '130px' }}
                                    >
                                        <img src={attributes?.['background-image']?.url ? attributes?.['background-image']?.url : attributes?.['background-image']?.external_url} />
                                    </CardMedia>
                                    <CardFooter className="softlite-footer-card-media">
                                        <MediaUploadCheck>
                                            <MediaUpload
                                                onSelect={(media) => handleSelectImage(media)}
                                                allowedTypes={'image'}
                                                //value={mediaId}
                                                render={({ open }) => (
                                                    <Button onClick={open} className='softlite-button-choose-image'>Change Image</Button>
                                                )}
                                            />
                                        </MediaUploadCheck>
                                    </CardFooter>
                                </Card>

                                <__experimentalInputControl
                                    placeholder='External URL'
                                    onChange={(newValue) => handleChangeImageBackground(newValue, false)}
                                    value={attributes?.['background-image']?.['external_url'] ?? ''}
                                    className="softlite-dynamic-inline"
                                    suffix={
                                        <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                            <DynamicDropdown onSelect={(shortcode) => handleChangeImageBackground(shortcode, true)} dynamicImage={true} />
                                        </__experimentalInputControlSuffixWrapper>}
                                />


                                {(attributes?.['background-image']?.url || attributes?.['background-image']?.['external_url']) && (
                                    <>
                                        <SelectControl
                                            label="Blend mode"
                                            options={[
                                                { label: 'Default', value: '' },
                                                { label: 'Normal', value: 'normal' },
                                                { label: 'Multiply', value: 'multiply' },
                                                { label: 'Screen', value: 'screen' },
                                                { label: 'Overlay', value: 'overlay' },
                                                { label: 'Darken', value: 'darken' },
                                                { label: 'Lighten', value: 'lighten' },
                                                { label: 'Color dodge', value: 'color-dodge' },
                                                { label: 'Saturation', value: 'saturation' },
                                                { label: 'Color', value: 'color' },
                                                { label: 'Luminosity', value: 'luminosity' },
                                                { label: 'Color burn', value: 'color-burn' },
                                                { label: 'Hard light', value: 'hard-light' },
                                                { label: 'Soft light', value: 'soft-light' },
                                                { label: 'Difference', value: 'difference' },
                                                { label: 'Exclusion', value: 'exclusion' },
                                                { label: 'Hue', value: 'hue' },
                                            ]}
                                            labelPosition="edge"
                                            className="softlite-select-control softlite-select-background-control"
                                            onChange={(newValue) => setAttributesResponsive('background-image.blend-mode', newValue, device, setAttributes, attributes)}
                                            value={attributes?.['background-image' + deviceString]?.['blend-mode'] ? attributes?.['background-image' + deviceString]?.['blend-mode'] : ''}
                                        />
                                        <SelectControl
                                            label="Attachment"
                                            options={[
                                                { label: 'Default', value: '' },
                                                { label: 'Scroll', value: 'scroll' },
                                                { label: 'Fixed', value: 'fixed' },
                                            ]}
                                            labelPosition="edge"
                                            className="softlite-select-control softlite-select-background-control"
                                            onChange={(newValue) => setAttributesResponsive('background-image.attachment', newValue, device, setAttributes, attributes)}
                                            value={attributes?.['background-image' + deviceString]?.['attachment'] ? attributes?.['background-image' + deviceString]?.['attachment'] : ''}
                                        />
                                        <SelectControl
                                            label="Position"
                                            options={[
                                                { label: 'Default', value: '' },
                                                { label: 'Top left', value: 'top left' },
                                                { label: 'Top center', value: 'top center' },
                                                { label: 'Top right', value: 'top right' },
                                                { label: 'Center left', value: 'center left' },
                                                { label: 'Center center', value: 'center center' },
                                                { label: 'Center right', value: 'center right' },
                                                { label: 'Bottom left', value: 'bottom left' },
                                                { label: 'Bottom center', value: 'bottom center' },
                                                { label: 'Bottom right', value: 'bottom right' },
                                                { label: 'Custom', value: 'custom' },
                                            ]}
                                            labelPosition="edge"
                                            className="softlite-select-control softlite-select-background-control"
                                            onChange={(newValue) => handleChangeBackgroundPosition(newValue)}
                                            value={attributes?.['background-image' + deviceString]?.['position'] ? attributes?.['background-image' + deviceString]?.['position'] : ''}
                                        />
                                        {bgPosition === 'custom' && (
                                            <>
                                                <TextControl
                                                    label="X axis"
                                                    onChange={(newX) => setAttributesResponsive('background-image.positionX', newX, device, setAttributes, attributes)}
                                                    value={attributes?.['background-image' + deviceString]?.positionX ? attributes?.['background-image' + deviceString]?.positionX : ''}
                                                    className="softlite-text-control"
                                                />
                                                <TextControl
                                                    label="Y axis"
                                                    onChange={(newY) => setAttributesResponsive('background-image.positionY', newY, device, setAttributes, attributes)}
                                                    value={attributes?.['background-image' + deviceString]?.positionY ? attributes?.['background-image' + deviceString]?.positionY : ''}
                                                    className="softlite-text-control"
                                                />
                                            </>
                                        )}
                                        <SelectControl
                                            label="Repeat"
                                            options={[
                                                { label: 'Default', value: '' },
                                                { label: 'No repeat', value: 'no-repeat' },
                                                { label: 'Repeat-x', value: 'repeat-x' },
                                                { label: 'Repeat-y', value: 'repeat-y' },
                                                { label: 'Repeat', value: 'repeat' },
                                            ]}
                                            labelPosition="edge"
                                            className="softlite-select-control softlite-select-background-control"
                                            onChange={(newValue) => setAttributesResponsive('background-image.repeat', newValue, device, setAttributes, attributes)}
                                            value={attributes?.['background-image' + deviceString]?.['repeat'] ? attributes?.['background-image' + deviceString]?.['repeat'] : ''}
                                        />
                                        <SelectControl
                                            label="Size"
                                            options={[
                                                { label: 'Default', value: '' },
                                                { label: 'Auto', value: 'auto' },
                                                { label: 'Cover', value: 'cover' },
                                                { label: 'Contain', value: 'contain' },
                                                { label: 'Custom', value: 'custom' },
                                            ]}
                                            labelPosition="edge"
                                            className="softlite-select-control softlite-select-background-control"
                                            onChange={(newSize) => handleChangeBackgroundSize(newSize)}
                                            value={attributes?.['background-image' + deviceString]?.['size'] ? attributes?.['background-image' + deviceString]?.['size'] : ''}
                                        />
                                        {bgSize == 'custom' && (
                                            <TextControl
                                                label="Custom size"
                                                onChange={(customSize) => setAttributesResponsive('background-image.sizeCustom', customSize, device, setAttributes, attributes)}
                                                value={attributes?.['background-image' + deviceString]?.sizeCustom ? attributes?.['background-image' + deviceString]?.sizeCustom : ''}
                                                className="softlite-text-control"
                                            />
                                        )}
                                    </>
                                )}

                            </PanelBody>
                        </>
                    )}
                </div>
                }
            </TabPanel>
        </>
    );
};

export default BacgroundControl;
